"use client";

import { Menu } from "lucide-react";
import Image from "next/image";
import Link from "next/link";
import { useState } from "react";
import useCurrentAccount from "@/components/context/useCurrentAccount";
import { Button } from "@/components/ui/Button";
import { Sheet, SheetContent, SheetHeader, SheetTitle, SheetTrigger } from "@/components/ui/sheet";
import { ThemeToggle } from "@/components/ui/theme-toggle";
import logoImg from "@/public/logo-no-text.svg";

const navigation: any[] = [
  // { name: 'Product', href: '/#product' },
  // { name: 'Features', href: '/#features' },
  // { name: 'Marketplace', href: '#' },
  // { name: 'Company', href: '#' },
];

export default function Header({}: {}) {
  const { account, isLoading } = useCurrentAccount();
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  return (
    <header className="sticky top-0 z-50 w-full border-b bg-background/95 backdrop-blur supports-[backdrop-filter]:bg-background/60">
      <div className="container mx-auto">
        <nav className="flex h-16 items-center justify-between px-4 sm:px-6" aria-label="Global">
          <div className="flex flex-1 items-center">
            <Link href="/" className="flex items-center space-x-2">
              <Image
                width={32}
                height={32}
                className="h-8 w-8"
                src={logoImg}
                alt="Uptime Monitor"
                priority
              />
              <span className="font-semibold text-lg">Uptime Monitor</span>
            </Link>
          </div>
          {/* Desktop Navigation */}
          <div className="hidden md:flex md:flex-1 md:justify-center">
            <div className="flex space-x-8">
              {navigation.map((item) => (
                <Link
                  key={item.name}
                  href={item.href}
                  className="text-sm font-medium text-muted-foreground transition-colors hover:text-foreground"
                >
                  {item.name}
                </Link>
              ))}
            </div>
          </div>
          {/* Desktop Actions */}
          <div className="hidden md:flex md:items-center md:space-x-4">
            <ThemeToggle />

            {!isLoading && !account && (
              <Link href="/accounts/login">
                <Button variant="default">Log in</Button>
              </Link>
            )}

            {!isLoading && account && (
              <Link href="/dashboard">
                <Button variant="default">My Dashboard</Button>
              </Link>
            )}

            {isLoading && <div className="h-10 w-24" />}
          </div>

          {/* Mobile Menu Button */}
          <div className="flex items-center space-x-2 md:hidden">
            <ThemeToggle />
            <Sheet open={mobileMenuOpen} onOpenChange={setMobileMenuOpen}>
              <SheetTrigger asChild>
                <Button variant="ghost" size="icon" className="md:hidden">
                  <Menu className="h-5 w-5" />
                  <span className="sr-only">Open menu</span>
                </Button>
              </SheetTrigger>
              <SheetContent side="right" className="w-[300px] sm:w-[400px]">
                <SheetHeader>
                  <SheetTitle>Navigation Menu</SheetTitle>
                </SheetHeader>
                <nav className="flex flex-col space-y-4 mt-6">
                  {navigation.map((item) => (
                    <Link
                      key={item.name}
                      href={item.href}
                      onClick={() => setMobileMenuOpen(false)}
                      className="text-base font-medium text-muted-foreground transition-colors hover:text-foreground"
                    >
                      {item.name}
                    </Link>
                  ))}

                  <div className="border-t pt-4">
                    {!isLoading && !account && (
                      <div className="space-y-2">
                        <Link
                          href="/accounts/login"
                          onClick={() => setMobileMenuOpen(false)}
                          className="block"
                        >
                          <Button variant="default" className="w-full">
                            Log in
                          </Button>
                        </Link>
                        <p className="text-center text-sm text-muted-foreground">
                          Don&apos;t have an account?{" "}
                          <Link
                            href="/accounts/login"
                            className="font-medium text-foreground hover:underline"
                            onClick={() => setMobileMenuOpen(false)}
                          >
                            Register
                          </Link>
                        </p>
                      </div>
                    )}

                    {!isLoading && account && (
                      <Link
                        href="/dashboard"
                        onClick={() => setMobileMenuOpen(false)}
                        className="block"
                      >
                        <Button variant="default" className="w-full">
                          My Dashboard
                        </Button>
                      </Link>
                    )}
                  </div>
                </nav>
              </SheetContent>
            </Sheet>
          </div>
        </nav>
      </div>
    </header>
  );
}
